import { render } from "./CoachForm.vue?vue&type=template&id=c553d00a&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=c553d00a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c553d00a"

export default script